<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Information Technology"
                   :links="[{title:'Home', url:'/'},{title:'Academic Calender'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="5"></sidebar>
        </section>
        <section class="content">
            <div class="heading-black1">Academic Calender</div>
            <iframe src="/static/pdf/computer/cv/test.pdf" height="600" width="100%"></iframe>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/it/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "Academic_Calender",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {div: null}
  }
}
</script>
<style lang="scss" scoped/>
